<template>
    <div class="md:flex mr-8 space-x-4 hidden">
        <Link
            href="/dashboard"
            class="text-sm text-gray-600 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
        >
            Dashboard
        </Link>
        <NDropdown
            trigger="hover"
            :options="enviosOptions"
            placement="bottom-end"
            size="large"
            style="font-size: 16px"
        >
            <button
                type="button"
                class="text-sm text-gray-600 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                id="user-menu-button"
                aria-expanded="false"
                data-dropdown-toggle="dropdown"
            >
                Envíos
            </button>
        </NDropdown>
        <NDropdown
            v-if="$page.props.user.tipo === 'sucursal_admin'"
            trigger="hover"
            :options="sucursalOptions"
            placement="bottom-end"
            size="large"
            style="font-size: 16px"
        >
            <button
                type="button"
                class="text-sm text-gray-600 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                id="user-menu-button"
                aria-expanded="false"
                data-dropdown-toggle="dropdown"
            >
                Sucursal
            </button>
        </NDropdown>
        <NDropdown
            v-if="$page.props.user.tipo === 'global_admin'"
            trigger="hover"
            :options="sucursalGlobalOptions"
            placement="bottom-end"
            size="large"
            style="font-size: 16px"
        >
            <button
                type="button"
                class="text-sm text-gray-600 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                id="user-menu-button"
                aria-expanded="false"
                data-dropdown-toggle="dropdown"
            >
                Email
            </button>
        </NDropdown>
        <Link
            v-if="$page.props.user.tipo === 'super_admin'"
            href="/clientes_globales"
            class="text-sm text-gray-600 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
        >
            Clientes globales
        </Link>
        <Link
            v-if="
                $page.props.user.tipo === 'super_admin' ||
                $page.props.user.tipo === 'global_admin'
            "
            href="/clientes"
            class="text-sm text-gray-600 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
        >
            Clientes
        </Link>
        <Link
            v-if="
                $page.props.user.tipo === 'super_admin' ||
                $page.props.user.tipo === 'global_admin' ||
                $page.props.user.tipo === 'cliente_admin'
            "
            href="/sucursales"
            class="text-sm text-gray-600 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
        >
            Sucursales
        </Link>
        <Link
            v-if="$page.props.user.tipo === 'super_admin'"
            href="/proveedores"
            class="text-sm text-gray-600 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
        >
            Proveedores
        </Link>
        <Link
            v-if="
                $page.props.user.tipo === 'super_admin' ||
                $page.props.user.tipo === 'global_admin'
            "
            href="/usuarios"
            class="text-sm text-gray-600 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
        >
            Usuarios
        </Link>
        <NDropdown
            v-if="$page.props.user.tipo === 'super_admin'"
            trigger="hover"
            :options="configOptions"
            placement="bottom-end"
            size="large"
            style="font-size: 16px"
        >
            <button
                type="button"
                class="text-sm text-gray-600 hover:text-primary-500 font-medium rounded-lg p-2 hover:bg-gray-100"
                id="user-menu-button"
                aria-expanded="false"
                data-dropdown-toggle="dropdown"
            >
                Config
            </button>
        </NDropdown>
    </div>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import { h } from "vue";
import { NDropdown, NIcon } from "naive-ui";

import {
    Key,
    CalendarCheckRegular,
    Boxes,
    ClipboardList,
    Plus,
    TrafficLight,
    Truck,
    Buromobelexperte,
    AddressBook,
    Book
} from "@vicons/fa";

export default {
    name: "Navbar",
    components: {
        Link,
        NDropdown,
        Key,
        CalendarCheckRegular,
        Boxes,
        ClipboardList,
        Plus,
        TrafficLight,
        Truck,
        Buromobelexperte,
        AddressBook,
        Book
    },
    data() {
        return {
            enviosOptions: [
                {
                    label: "Listado",
                    key: "listado",
                    icon: this.renderIcon(Boxes),
                    props: {
                        onClick: () => {
                            this.$inertia.visit("/envios");
                        },
                    },
                },
                {
                    label: "Crear envío",
                    key: "crear-envio",
                    icon: this.renderIcon(Plus),
                    props: {
                        onClick: () => {
                            this.$inertia.visit("/envios/crear");
                        },
                    },
                },
                {
                    label: "Mercado envíos",
                    key: "mercado-envio",
                    icon: this.renderIcon(Plus),
                    props: {
                        onClick: () => {
                            this.$inertia.visit("/mercado-envios");
                        },
                    },
                },
                {
                    label: "Carga Multiple",
                    key: "carga-multiple",
                    icon: this.renderIcon(ClipboardList),
                    props: {
                        onClick: () => {
                            this.$inertia.visit("/carga_excel");
                        },
                    },
                },
                {
                    label: "Envios Pendientes",
                    key: "envio-pendiente",
                    icon: this.renderIcon(CalendarCheckRegular),
                    props: {
                        onClick: () => {
                            this.$inertia.visit("/envios_multiple");
                        },
                    },
                },
                {
                    label: "Directorio",
                    key: "directorio",
                    icon: this.renderIcon(AddressBook),
                    props: {
                        onClick: () => {
                            this.$inertia.visit("/directorio");
                        },
                    },
                },
                {
                    label: "Categorias",
                    key: "categorias",
                    icon: this.renderIcon(Book),
                    props: {
                        onClick: () => {
                            this.$inertia.visit("/categorias");
                        },
                    },
                },
            ],
            configOptions: [
                {
                    label: "Parametros",
                    key: "parametros",
                    icon: this.renderIcon(Key),
                    props: {
                        onClick: () => {
                            this.$inertia.visit("/parametros");
                        },
                    },
                },
                {
                    label: "Cordones",
                    key: "cordones",
                    icon: this.renderIcon(ClipboardList),
                    props: {
                        onClick: () => {
                            this.$inertia.visit("/cordones");
                        },
                    },
                },
                {
                    label: "SLA",
                    key: "sla",
                    icon: this.renderIcon(CalendarCheckRegular),
                    props: {
                        onClick: () => {
                            this.$inertia.visit("/sla_envios");
                        },
                    },
                },
                {
                    label: "Estados",
                    key: "estados",
                    icon: this.renderIcon(TrafficLight),
                    props: {
                        onClick: () => {
                            this.$inertia.visit("/estados");
                        },
                    },
                },
                {
                    label: "Servicios",
                    key: "servicios",
                    icon: this.renderIcon(Truck),
                    props: {
                        onClick: () => {
                            this.$inertia.visit("/servicios");
                        },
                    },
                },
                {
                    label: "Codigos postales",
                    key: "cps",
                    icon: this.renderIcon(Buromobelexperte),
                    props: {
                        onClick: () => {
                            this.$inertia.visit("/cps");
                        },
                    },
                },
            ],
            sucursalOptions: [
                {
                    label: "Personalizar Email",
                    key: "email",
                    icon: this.renderIcon(ClipboardList),
                    props: {
                        onClick: () => {
                            this.$inertia.visit("/sucursales/email");
                        },
                    },
                }
            ],
            sucursalGlobalOptions: [
                {
                    label: "Personalizar Email",
                    key: "email",
                    icon: this.renderIcon(ClipboardList),
                    props: {
                        onClick: () => {
                            this.$inertia.visit("/configuraciones/email");
                        },
                    },
                }
            ],
        };
    },
    methods: {
        renderIcon(icon) {
            return () => {
                return h(NIcon, null, {
                    default: () => h(icon),
                });
            };
        },
        logout() {
            this.$inertia.post(route("logout"));
        },
    },
};
</script>
